import googleMaps from '@/helpers/config/google-maps';
import server from '@/helpers/config/server';
import environment from '@/helpers/config/environment';

export default {
  googleMaps,
  server,
  environment
};
